import { LegendLabel } from '../../types/chart';

type LegendChartProps = {
  labels: LegendLabel[];
  reportInc?: boolean
};

function LegendChart({ labels, reportInc }: LegendChartProps) {
  return (
    <>
      <ul className="mt-6 flex justify-center gap-4">
        {labels.map((label, index) => (
          <li key={index} className="flex items-center gap-2">
            <div
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: label.color }}
            ></div>
            <span className="text-[#637381]">{label.text}</span>
          </li>
        ))}
      </ul>
      {reportInc && labels.length <= 2 &&
        <ul className="mt-6 flex justify-center gap-4">
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
          <li><div
            className="h-3 w-3 rounded-full"
            style={{ backgroundColor: '#FFF' }}
          ></div><span className="text-[#FFF]">Заполнение</span></li>
        </ul>
      }
    </>
  );
}

export default LegendChart;
